import React from "react";

import { useTranslation } from "react-i18next";

import Logo from "~/assets/images/logo.svg";

import * as styles from "./styles";

export const Attribution = ({ onClick }: { onClick?: () => void }) => {
  const { t } = useTranslation(["common"]);

  return (
    <a
      onClick={onClick}
      className={styles.container}
      href="https://locallogic.co/"
      target="_blank"
      rel="noreferrer"
    >
      {t("common:attribution")}
      <Logo />
    </a>
  );
};
